import React from "react";
import { Modal, Text } from "@networkraildigitalfactory/components";
import styles from "./WarningModals.module.css";
import Browsers from "../../../assets/browsers.svg";
import Desktop from "../../../assets/desktop.svg";
import useDisableScroll from "../../../hooks/useDisableScroll";

export const WarningModalIE = (props) => {
  useDisableScroll(props.show);
  return (
    <Modal
      type="alert"
      cancelText="Close"
      cancelButtonColor="blue"
      show={props.show}
      onClose={props.close}
      style={{ maxWidth: "453px", position: "fixed" }}
    >
      <div className={styles.ie_fixMinHeight}>
        <div className={styles.WarningModal}>
          <img src={Browsers} alt="browser logos" height={200} />
          <Text
            wrapper="h1"
            type="subtitle"
            style={{ lineHeight: "140%", letterSpacing: "0.0015em" }}
          >
            Welcome to the 21st Century
          </Text>
          <Text
            wrapper="p"
            type="body"
            style={{ wordWrap: "break-word", lineHeight: "140%", letterSpacing: "0.0015em" }}
          >
            It looks like you are using Internet Explorer. Here in the Digital Factory, we develop
            our web apps using modern technologies that Internet Explorer doesn't support well. For
            the best user experience, we
            <b> strongly </b>
            advise switching to Microsoft Edge or Google Chrome.
          </Text>
        </div>
      </div>
    </Modal>
  );
};

export const WarningModalMobile = (props) => {
  useDisableScroll(props.show);
  return (
    <Modal
      type="alert"
      cancelText="Close"
      cancelButtonColor="blue"
      show={props.show}
      onClose={props.close}
      style={{ maxWidth: "90%", width: "453px", position: "fixed" }}
    >
      <div className={styles.WarningModal}>
        <img src={Desktop} alt="browser logos" width={200} height={150} />
        <Text
          wrapper="h1"
          type="subtitle"
          style={{ lineHeight: "140%", letterSpacing: "0.0015em" }}
        >
          Please Switch Devices
        </Text>
        <Text wrapper="p" type="body" style={{ lineHeight: "140%", letterSpacing: "0.0015em" }}>
          It looks like you are using a mobile device. This web app was developed with the intention
          of being used on larger screens such as desktops and laptops. If you think this should be
          changed please let us know at:{" "}
          <a href="mailto:digitalfactory@networkrail.co.uk">DigitalFactory@networkrail.co.uk</a>
        </Text>
      </div>
    </Modal>
  );
};

export const AccessDeniedModal = (props) => {
  return (
    <Modal
      type="alert"
      cancelText="OK"
      cancelButtonColor="blue"
      show={props.show}
      onClose={props.close}
      style={{ maxWidth: "90%", width: "453px", position: "fixed" }}
    >
      <div className={styles.WarningModal}>
        <Text
          wrapper="h1"
          type="subtitle"
          style={{ lineHeight: "140%", letterSpacing: "0.0015em" }}
        >
          Access Denied
        </Text>
        <Text wrapper="p" type="body" style={{ lineHeight: "140%", letterSpacing: "0.0015em" }}>
          You must be listed as the employee’s line manager or additional line manager to view this
          information.
        </Text>
      </div>
    </Modal>
  );
};
